'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _themeColors = require('../ds-header/themeColors');

var _themeColors2 = _interopRequireDefault(_themeColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'side-navigation';

var SideNavigation = function (_React$Component) {
  _inherits(SideNavigation, _React$Component);

  function SideNavigation(props) {
    _classCallCheck(this, SideNavigation);

    var _this = _possibleConstructorReturn(this, (SideNavigation.__proto__ || Object.getPrototypeOf(SideNavigation)).call(this, props));

    _this.handleMenuClick = _this.handleMenuClick.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleHeroEvent = _this.handleHeroEvent.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.theme = '#003087';
    _this.state = {
      menuOpen: true,
      userInteraction: false,
      l1: [],
      l2: [],
      highlightSection: ''
    };
    return _this;
  }

  _createClass(SideNavigation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('DSHeroTheme', this.handleHeroEvent);
      this.handleScroll();
      this.handleHighlight();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.addEventListener('DSHeroTheme', this.handleHeroEvent);
    }
  }, {
    key: 'handleHighlight',
    value: function handleHighlight() {
      var path = window.location.pathname;
      var pathArr = path.split('/');
      var categoryIndex = pathArr.indexOf('guidelines') + 1;
      var highlightSection = categoryIndex !== 0 ? pathArr[categoryIndex] : '';
      this.setState({
        highlightSection: highlightSection
      });
    }
  }, {
    key: 'handleHeroEvent',
    value: function handleHeroEvent(e) {
      if (e && e.theme) {
        this.theme = _themeColors2.default[e.theme];
        this.forceUpdate();
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (!this.state.userInteraction) {
        if (window.scrollY > 50) {
          this.setState({
            menuOpen: false
          });
        } else {
          this.setState({
            menuOpen: true
          });
        }
      }
    }
  }, {
    key: 'handleMenuClick',
    value: function handleMenuClick() {
      this.setState({
        menuOpen: !this.state.menuOpen,
        userInteraction: true
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e, index, level) {
      e.preventDefault();
      var activeSections = [].concat(_toConsumableArray(this.state[level]));
      if (this.props.config.accordion) {
        activeSections = activeSections[0] === index ? [] : [index];
      } else {
        var idx = activeSections.indexOf(index);
        if (idx > -1) {
          activeSections.splice(idx, 1);
        } else {
          activeSections.push(index);
        }
      }
      var obj = { userInteraction: true };
      obj[level] = activeSections;
      if (level === 'l1') {
        obj.l2 = [];
      }
      this.setState(obj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config;
      var menu = content.menu,
          sections = content.sections;
      var position = config.position;


      var classes = (0, _classnames2.default)('side-navigation', {
        active: this.state.menuOpen
      }, position);
      /* Better performance if calculated once in componentDidMount? */
      var maxHeightOpened = 300 * (sections.length + 1);
      if (typeof window !== 'undefined') {
        if (maxHeightOpened > window.innerHeight) {
          maxHeightOpened = window.innerHeight - 36; // composate top padding of the nav
        }
      }
      return _react2.default.createElement(
        'nav',
        {
          className: classes,
          style: { maxHeight: this.state.menuOpen ? maxHeightOpened : 60 },
          ref: function ref(c) {
            _this2.header = c;
          }
        },
        _react2.default.createElement(
          'button',
          {
            className: ORGANISM_NAME + '__menu-btn pp-sans-small-medium',
            onClick: this.handleMenuClick,
            style: { borderColor: this.theme }
          },
          menu.text
        ),
        sections && _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__menu' },
          _react2.default.createElement(
            'ul',
            { className: ORGANISM_NAME + '__sections' },
            sections.map(function (section, index) {
              var categories = section.categories;

              var sectionAnchor = _react2.default.createElement(
                'a',
                { href: section.href },
                section.text
              );
              var isActive = _this2.state.l1.indexOf(index) > -1;
              var sectionKey = section.text + index;
              if (categories) {
                sectionAnchor = _react2.default.createElement(
                  'a',
                  {
                    href: section.href,
                    className: ORGANISM_NAME + '__section-anchor ' + (isActive ? 'active' : ''),
                    onClick: function onClick(e) {
                      return _this2.handleClick(e, index, 'l1');
                    }
                  },
                  section.text
                );
              }
              return _react2.default.createElement(
                'li',
                { key: sectionKey, className: section.color + ' ' + (_this2.state.highlightSection === section.id ? 'highlight' : '') },
                sectionAnchor,
                categories && _react2.default.createElement(
                  'ul',
                  { className: ORGANISM_NAME + '__categories ' + (isActive ? 'active' : '') },
                  categories.map(function (category, index2) {
                    var pages = category.pages;

                    var categoryAnchor = _react2.default.createElement(
                      'a',
                      { href: category.href },
                      category.text
                    );
                    var isActive2 = _this2.state.l2.indexOf(index2) > -1;
                    var categoryKey = category.text + index2;
                    if (pages) {
                      categoryAnchor = _react2.default.createElement(
                        'a',
                        {
                          href: category.href,
                          className: ORGANISM_NAME + '__section-anchor ' + (isActive2 ? 'active' : ''),
                          onClick: function onClick(e) {
                            return _this2.handleClick(e, index2, 'l2');
                          }
                        },
                        category.text
                      );
                    }
                    return _react2.default.createElement(
                      'li',
                      { key: categoryKey },
                      categoryAnchor,
                      pages && _react2.default.createElement(
                        'ul',
                        { className: ORGANISM_NAME + '__pages ' + (isActive2 ? 'active' : '') },
                        pages.map(function (page) {
                          return _react2.default.createElement(
                            'li',
                            { key: page.text },
                            _react2.default.createElement(
                              'a',
                              { href: page.href },
                              page.text
                            )
                          );
                        })
                      )
                    );
                  })
                )
              );
            })
          )
        )
      );
    }
  }]);

  return SideNavigation;
}(_react2.default.Component);

exports.default = SideNavigation;


SideNavigation.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    accordion: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({})
};

SideNavigation.defaultProps = {
  config: {
    id: '',
    accordion: true,
    position: 'right'
  },
  content: {
    menu: {
      text: 'MENU'
    },
    sections: [{
      text: 'Introduction',
      href: '/webapps/mpp/guidelines',
      color: 'pay-blue'
    }, {
      text: 'Design',
      href: '#',
      color: 'purple',
      id: 'design',
      categories: [{
        text: 'Design system',
        href: '/webapps/mpp/guidelines/design'
      }, {
        text: 'Organism library',
        href: '#',
        pages: [{
          text: 'View all',
          href: '/webapps/mpp/guidelines/design/library'
        }, {
          text: 'Hero',
          href: '/webapps/mpp/guidelines/design/library#hero'
        }, {
          text: 'Compare',
          href: '/webapps/mpp/guidelines/design/library#compare'
        }, {
          text: 'CTAs and links',
          href: '/webapps/mpp/guidelines/design/library#ctalinks'
        }, {
          text: 'Featured merchants',
          href: '/webapps/mpp/guidelines/design/library#featuredmerchants'
        }, {
          text: 'Features and benefits',
          href: '/webapps/mpp/guidelines/design/library#featuresbenefits'
        }, {
          text: 'Fees and pricing',
          href: '/webapps/mpp/guidelines/design/library#feespricing'
        }, {
          text: 'Offers',
          href: '/webapps/mpp/guidelines/design/library#offers'
        }, {
          text: 'Page elements',
          href: '/webapps/mpp/guidelines/design/library#pageelements'
        }, {
          text: 'Social and testimonial',
          href: '/webapps/mpp/guidelines/design/library#socialtestimonial'
        }, {
          text: 'Steps',
          href: '/webapps/mpp/guidelines/design/library#steps'
        }, {
          text: 'Video',
          href: '/webapps/mpp/guidelines/design/library#video'
        }, {
          text: 'Footer',
          href: '/webapps/mpp/guidelines/design/library#footer'
        }]
      }, {
        text: 'Resources',
        href: '/webapps/mpp/guidelines/design/resources'
      }]
    }, {
      text: 'Build',
      href: '#',
      color: 'pink',
      id: 'build',
      categories: [{
        text: 'Production options',
        href: '/webapps/mpp/guidelines/build'
      }, {
        text: 'Canvas',
        href: '/webapps/mpp/guidelines/build/canvas'
      }, {
        text: 'Edit page information',
        href: '/webapps/mpp/guidelines/build/edit-page-information'
      }, {
        text: 'Image Optimization',
        href: '/webapps/mpp/guidelines/build/image-optimization'
      }]
    }, {
      text: 'Evolve',
      href: '/webapps/mpp/guidelines/evolve',
      color: 'orange',
      id: 'evolve'
    }, {
      text: 'Get help',
      href: '/webapps/mpp/guidelines/get-help',
      color: 'green',
      id: 'get-help'
    }]
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/side-navigation/SideNavigation.js
// module id = 576
// module chunks = 4